import { createApi } from "@reduxjs/toolkit/query/react";
import { extendedBaseQuery } from "../basequery";

export const googleAnalyticsConfigApi = createApi({
  reducerPath: "googleAnalyticsConfigApi",
  baseQuery: extendedBaseQuery,
  tagTypes: ["GoogleAnalyticsConfig", "DashboardCardOrder"],
  endpoints: (builder) => ({
    getGoogleAnalyticsConfigs: builder.query({
      query: (params) => {
        const query = {};
        if (params?.skip) query.skip = params.skip;
        if (params?.limit) query.limit = params.limit;
        if (params?.search) query.search = params.search;
        if (params?.filter) query.filter = params.filter;
        if (params?.sortBy) query.sortBy = params.sortBy;
        if (params?.orderBy) query.orderBy = params.orderBy;
        if (params?.roleId) query.roleId = params.roleId;
        if (params?.authUserId) query.authUserId = params.authUserId;
        if (params?.keyName) query.keyName = params.keyName;
        if (params?.graphId) query.graphId = params.graphId;

        const queryString = new URLSearchParams(query).toString();
        return {
          url: `google-analytics-config/by-user${queryString ? `?${queryString}` : ""}`,
          method: "GET",
        };
      },
      providesTags: ["GoogleAnalyticsConfig"],
    }),
    getAllKeys: builder.query({
      query: (params) => {
        const query = {};
        if (params?.graphId) query.graphId = params.graphId;

        return {
          url: `google-analytics-config/all-keys?${new URLSearchParams(
            query,
          ).toString()}`,
          method: "GET",
        };
      },
      providesTags: ["GoogleAnalyticsConfig"],
    }),
    getGoogleAnalyticsConfigById: builder.query({
      query: (id) => ({
        url: `google-analytics-config/${id}`,
        method: "GET",
      }),
      providesTags: ["GoogleAnalyticsConfig"],
    }),
    createGoogleAnalyticsConfig: builder.mutation({
      query: (body) => ({
        url: "google-analytics-config/create",
        method: "POST",
        body,
      }),
      invalidatesTags: ["GoogleAnalyticsConfig"],
    }),
    updateGoogleAnalyticsConfig: builder.mutation({
      query: (body) => ({
        url: `google-analytics-config/${body.id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["GoogleAnalyticsConfig"],
    }),
    // Bulk update index for reordering cards
    bulkUpdateIndex: builder.mutation({
      query: (body) => ({
        url: "google-analytics-config/bulk/update-index",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["GoogleAnalyticsConfig"],
    }),
  }),
});

export const {
  useGetGoogleAnalyticsConfigsQuery,
  useGetGoogleAnalyticsConfigByIdQuery,
  useCreateGoogleAnalyticsConfigMutation,
  useUpdateGoogleAnalyticsConfigMutation,
  useGetAllKeysQuery,
  useBulkUpdateIndexMutation,
} = googleAnalyticsConfigApi;
